import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The server is the only writer and it is on the same machine, so data is
      // effectively never stale between our own mutations.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // A 401 means the session is gone; retrying just delays the login screen.
      retry: (failureCount, error) =>
        !(error instanceof Error && 'status' in error && error.status === 401) &&
        failureCount < 2,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
